import LogoutIcon from '@mui/icons-material/Logout';
import { Box, ListItemButton, Slide, Stack } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { logoutUser } from 'lib/api';
import React from 'react';
import { useDispatch } from 'react-redux';
import { logout } from 'services/redux/authSlice';

import IconText from '../IconText';
import UserInfo from '../UserInfo';

export interface MobileSidebarItem {
  label: string;
  path: string;
  icon: React.ReactNode;
}

export interface MobileSidebarProps {
  open: boolean;
  onClose: () => void;
  items: MobileSidebarItem[];
  onItemClick: (path: string) => void;
}

const MobileSidebar: React.FC<MobileSidebarProps> = ({
  open,
  onClose,
  items,
  onItemClick,
}) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const handleLogout = async () => {
    await logoutUser(dispatch);
    queryClient.clear();
    dispatch(logout());
    onClose();
  };

  const handleClose = (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    onClose();
  };

  return (
    <>
      <Slide in={open} direction="left" mountOnEnter unmountOnExit>
        <Box
          component="nav"
          role="presentation"
          onClick={handleClose}
          onKeyDown={handleClose}
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: (theme) => theme.zIndex.drawer,
            width: '100%',
            height: '100%',
            backgroundColor: 'background.paper',
            pt: 2,
            overflow: 'hidden',
            pointerEvents: open ? 'auto' : 'none',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              px: 2,
              py: 1,
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              minHeight: 0,
            }}
          >
            <Box
              sx={{
                overflow: 'auto',
              }}
            >
              <Stack spacing={1}>
                {items.map(({ label, icon, path }) => (
                  <ListItemButton
                    key={path}
                    onClick={() => {
                      onItemClick(path);
                      onClose();
                    }}
                  >
                    <IconText icon={icon}>{label}</IconText>
                  </ListItemButton>
                ))}
              </Stack>
            </Box>

            <Box sx={{ mt: 'auto', mb: 5 }}>
              <ListItemButton
                sx={{ justifyContent: 'flex-start' }}
                onClick={() => void handleLogout()}
              >
                <IconText icon={<LogoutIcon />}>Cerrar sesión</IconText>
              </ListItemButton>
              <Box sx={{ mt: 5 }}>
                <UserInfo />
              </Box>
            </Box>
          </Box>
        </Box>
      </Slide>
    </>
  );
};

export default MobileSidebar;
